export default __webpack_public_path__ + "static/media/tailwind.ae40dbca.png";